/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Banner as BannerComponent } from "../../sharedComponents/Banner";
// eslint-disable-next-line import/no-cycle
import { Button } from "../Button";
import * as styles from "./Banner.module.scss";

const Banner = ({ image, link, text }) => (
	<BannerComponent className={styles} image={image} customButton={Button} link={link} text={text} />
);

Banner.propTypes = {
	image: PropTypes.shape({
		url: PropTypes.string,
		alt: PropTypes.string,
	}).isRequired,
	link: PropTypes.shape({
		url: PropTypes.string,
		linkText: PropTypes.string,
		linkTarget: PropTypes.string,
	}),
	text: PropTypes.string.isRequired,
};

Banner.defaultProps = {
	link: {},
};

export default Banner;
export { Banner };
